import type { DomainSchema, PdfCardDef } from '../types';
import { fmtDate, esc, metaJoin } from '../pdf-helpers';

export const CERTIFICATIONS = {
  priority: true,
  cardTitle: '{name}',
  fields: {
    name: { type: 'text' },
    authority: { type: 'text', label: 'Issuing Authority' },
    licenseNumber: { type: 'text', label: 'License Number' },
    url: { type: 'text', label: 'URL' },
    issueDate: { type: 'date', label: 'Issue Date' },
    expirationDate: { type: 'date', label: 'Expiration Date' },
    // startDate / endDate are occasionally present as aliases — keep but hide
    startDate: { type: 'date', hidden: true },
    endDate: { type: 'date', hidden: true },
  },
  layout: [
    [{ field: 'authority' }, { field: 'licenseNumber' }],
    [
      { field: 'issueDate', width: 50 },
      { field: 'expirationDate', width: 50 },
    ],
    [{ field: 'url' }],
  ],
  editLayout: [
    [{ field: 'name' }],
    [{ field: 'authority' }, { field: 'licenseNumber' }],
    [
      { field: 'issueDate', width: 50 },
      { field: 'expirationDate', width: 50 },
    ],
    [{ field: 'url' }],
  ],
} satisfies DomainSchema;

export const CertificationsPdfCard: PdfCardDef = {
  styles: `
    .cert-item { padding: 0.65rem 0; border-bottom: 1px solid var(--line); }
    .cert-item:first-child { padding-top: 0; }
    .cert-item:last-child { border-bottom: none; padding-bottom: 0; }
    .cert-name { font-size: 13px; font-weight: 700; }
    .cert-meta { font-size: 11px; color: var(--muted); margin-top: 2px; }
  `,
  render(records) {
    return records
      .map(r => {
        const meta = metaJoin([
          r['authority'] ? esc(r['authority']) : null,
          r['issueDate'] ? fmtDate(r['issueDate']) : null,
          r['licenseNumber'] ? `No. ${esc(r['licenseNumber'])}` : null,
        ]);
        return `
          <div class="cert-item">
            <div class="cert-name">${esc(r['name'])}</div>
            ${meta ? `<div class="cert-meta">${meta}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
